import { render, staticRenderFns } from "./msgTips.vue?vue&type=template&id=fa7b12fc"
import script from "./msgTips.vue?vue&type=script&lang=js"
export * from "./msgTips.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports